/**
 * Visible glyph used in transcript content to mark an explicit line break token.
 * This is not the newline character (`\n`).
 */
export const LINE_BREAK_CHARACTER = '↵';

/**
 * The single space glyph used as the default word separator in transcript text.
 */
export const SPACE = ' ';
